import type { MessageKey } from './en';

const de: Record<MessageKey, string> = {
  lang_switch_label: 'Sprache',

  global_empty_state_title: 'Noch nichts hier',
  global_empty_state_description: 'Warte, bis das erste Objekt eingetragen wird...',
  pagination_go_to_page: 'Gehe zu Seite',
  pagination_items_per_page: 'Einträge pro Seite',
  pagination_first_page: 'Erste Seite',
  pagination_previous_page: 'Vorherige Seite',
  pagination_next_page: 'Nächste Seite',
  pagination_last_page: 'Letzte Seite',

  login_welcome_back: 'Willkommen zurück',
  login_subtitle: 'Melde dich mit E-Mail und Passwort an.',
  login_email_label: 'E-Mail',
  login_password_label: 'Passwort',
  login_button: 'Anmelden',
  login_forgot_password: 'Passwort vergessen?',
  login_reset_it: 'Zurücksetzen',
  login_error_user_not_found: 'E-Mail und Passwort stimmen nicht mit unseren Daten überein.',
  login_error_wrong_password: 'Falsches Passwort.',
  login_error_invalid_email: 'Ungültige E-Mail-Adresse.',
  login_error_user_disabled: 'Dieses Konto wurde deaktiviert.',
  login_error_login_failed: 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
  login_unexpected_error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
  login_need_account: 'Noch kein Konto?',
  login_go_signup: 'Registrieren',

  signup_create_account: 'Konto erstellen',
  signup_get_started_description: 'Verwende dieselbe E-Mail wie in der Produktion.',
  signup_display_name_label: 'Anzeigename (optional)',
  signup_email_label: 'E-Mail',
  signup_password_label: 'Passwort',
  signup_confirm_password_label: 'Passwort bestätigen',
  signup_passwords_do_not_match: 'Passwörter stimmen nicht überein.',
  signup_button: 'Konto erstellen',
  signup_already_have_account: 'Bereits ein Konto?',
  signup_login_link: 'Anmelden',
  signup_email_already_in_use: 'Diese E-Mail ist bereits registriert.',
  signup_weak_password: 'Passwort ist zu schwach. Mindestens 6 Zeichen verwenden.',
  signup_unexpected_error: 'Konto konnte nicht erstellt werden. Bitte erneut versuchen.',
  signup_firestore_hint:
    'Erstellt ein Firestore-Dokument unter users/{uid}. Stelle sicher, dass deine Sicherheitsregeln dem angemeldeten Nutzer erlauben, sein Profil zu schreiben.',

  reset_password_title: 'Passwort zurücksetzen',
  reset_password_subtitle: 'Wir senden dir einen Link, um ein neues Passwort zu wählen.',
  reset_password_email_label: 'E-Mail',
  reset_password_send_button: 'Link senden',
  reset_password_remembered_password: 'Passwort wieder eingefallen?',
  reset_password_back_to_login: 'Zur Anmeldung',
  reset_password_success_message:
    'Wenn ein Konto für diese E-Mail existiert, erhältst du in Kürze einen Link.',
  reset_password_error_unauthorized_domain:
    'Diese Domain ist für Passwort-Reset nicht autorisiert. Füge sie unter Firebase Console → Authentication → Settings → Authorized domains hinzu.',
  reset_password_error_no_account_found: 'Kein Konto für diese E-Mail gefunden.',
  reset_password_error_invalid_email: 'Bitte gib eine gültige E-Mail-Adresse ein.',
  reset_password_error_link_not_sent: 'Link konnte nicht gesendet werden. Bitte später erneut versuchen.',
  reset_password_unexpected_error: 'Etwas ist schiefgelaufen. Bitte erneut versuchen.',
  reset_password_action_url_hint:
    'Setze die Firebase Auth Action URL (Continue URL) auf /confirm-password auf dieser Origin, damit der Link diesen Bildschirm öffnet.',

  reset_password_new_password_title: 'Neues Passwort wählen',
  reset_password_new_password_subtitle: 'Gib dein neues Passwort ein und bestätige es.',
  reset_password_verifying: 'Reset-Link wird geprüft…',
  reset_password_error_code_invalid: 'Dieser Reset-Link ist ungültig oder wurde bereits verwendet.',
  reset_password_error_code_expired: 'Dieser Reset-Link ist abgelaufen. Fordere einen neuen an.',
  reset_password_new_password_label: 'Neues Passwort',
  reset_password_confirm_password_label: 'Neues Passwort bestätigen',
  reset_password_reset_button: 'Passwort aktualisieren',
  reset_password_success_reset: 'Passwort aktualisiert. Weiterleitung zur Anmeldung…',
  reset_password_error_passwords_mismatch: 'Passwörter stimmen nicht überein.',
  reset_password_error_password_too_short: 'Mindestens 6 Zeichen verwenden.',
  reset_password_error_weak_password: 'Passwort ist zu schwach. Wähle ein stärkeres.',
  reset_password_error_generic: 'Passwort konnte nicht zurückgesetzt werden. Bitte erneut versuchen.',
  reset_password_request_new_link: 'Neuen Reset-Link anfordern',
};

export default de;
